// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wiki-page-header[data-v-a76c7afa]{font-size:0;padding-bottom:5px;margin-left:0;margin-right:0}.wiki-page-header__label[data-v-a76c7afa]{font-size:28px;font-weight:600;line-height:28px;display:block}\n", ""]);
// Exports
module.exports = exports;
